export default __webpack_public_path__ + "assets/arrow-59b551ef387386731870583765b507e9.png";